let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6a8Xq")).then(() => parcelRequire('deElx'));